import React from "react"
import styled from "styled-components"
import TesteGratis from "./teste_gratis"

const Wrapper = styled.div`
  color: var(--cPrimary);
  display: flex;
  justify-content: space  -between;
  align-items: center;
  margin-top: 60px;
  margin-bottom: 60px;
  overflow-x: hidden;
  gap: 200px;
  @media(max-width: 919px) {
    flex-direction: column;
    gap: 20px;

  }
`

const Title = styled.h2`
  font-size: 2rem;
  line-height: 42px;
  margin-top: 0 ;
  margin-bottom: 10px;
  @media(max-width: 919px) {
    text-align: center;

  }
`


const Description = styled.p`
  font-size: 1rem;
  font-weight: 300;
  @media(max-width: 919px) {
    text-align: center;
    margin-top: 20px;

  }
`

const Text = styled.p`
  font-size: 1rem;
  line-height: 25px;
  font-weight: 300;
  @media(max-width: 919px) {
    text-align: center;
    margin-top: 30px;
    margin-bottom: 30px;

  }
`


const Action = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;

  @media(max-width: 919px) {
    width: 100%;
    a {
      width: 100%;
    }
  }
`


// const Wrapper = styled.div``

const Band = ({ handle }) => (
  <section className="mSection" style={{marginTop: 0}}>
    <Wrapper className="container">
      <div data-aos='fade-right' data-aos-offset="0" data-aos-duration="600">
        <Title>Facilite a gestão de sua empresa :)</Title>
        <Text>O TagPlus já ajudou mais de 60 mil empresas a serem mais eficientes e organizadas.</Text>
      </div>
         <Action data-aos='fade-left' data-aos-offset="0" data-aos-duration="600">
          <TesteGratis />
          <Description>15 dias para testar</Description>
         </Action>
    </Wrapper>
    
  </section>
 
)
export default Band
